<template>
	<div>
		<el-dialog
		 title="新增会员"
		 :class="size"
		 :visible.sync="dialogFormVisible"
		 :close-on-click-modal="false"
		 @close="submitTap('1')">
		  <el-form :model="form" :rules="rules" ref="ruleForm" style="width:500px;">
				<el-form-item label="会员昵称:" prop="user_nickname" :label-width="formLabelWidth">
					<el-input v-model="form.user_nickname" placeholder="请输入昵称" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="会员卡号:" prop="card_no" :label-width="formLabelWidth">
					<el-input v-model="form.card_no" placeholder="请输入会员卡号" autocomplete="off"></el-input>
				</el-form-item>
		    <el-form-item label="会员姓名:" prop="real_name" :label-width="formLabelWidth">
					<el-input v-model="form.real_name" placeholder="请输入姓名" autocomplete="off"></el-input>
		    </el-form-item>
				<el-form-item label="会员级别:" prop="group_id" :label-width="formLabelWidth">
					<el-select v-model="form.group_id" placeholder="请选择级别" style="width:100%;">
						<el-option
							v-for="grade in gradeList"
							:key="grade.group_id"
							:label="grade.group_name"
							:value="grade.group_id"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="手机号码:" prop="mobile" :label-width="formLabelWidth">
					<el-input v-model="form.mobile" placeholder="请输入手机号码" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="微信号:" prop="weixin_no" :label-width="formLabelWidth">
					<el-input v-model="form.weixin_no" placeholder="请输入微信号" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="性别:" prop="sex" :label-width="formLabelWidth">
					<el-radio-group v-model="form.sex">
							<el-radio :label="1">男</el-radio>
							<el-radio :label="2">女</el-radio>
						</el-radio-group>
				</el-form-item>
				<el-form-item label="生日:"  prop="birthday" :label-width="formLabelWidth">
					<el-date-picker
						v-model="form.birthday"
						value-format="yyyy-MM-dd"
						type="date"
						style="width:100%;"
						placeholder="请设置生日"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="地址:" prop="province_id"  :label-width="formLabelWidth">
					<region  @address="getAddress"></region>
				</el-form-item>
				<el-form-item label="详细地址:" prop="address" :label-width="formLabelWidth">
					<el-input v-model="form.address" placeholder="请输入详细地址" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注:"  prop="remake" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="form.remake" placeholder="请输入备注" style="height:50px;"></el-input>
				</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="submitTap('1')">取 消</el-button>
		    <el-button type="FF7" @click="submitTap('2','ruleForm')">保 存</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import region from '@/components/common/region.vue'
	export default {
		name:'addUser',
		props:['status','size'],
		components: {
			region
		},
		data() {
		  return {
				dialogFormVisible:false,
				form: {
					real_name: '',
					user_nickname:'',
					card_no: '',
					group_id:'',
					mobile:'',
					weixin_no:'',
					sex:'',
					birthday:'',
					address:'',
					province_id: '',
					city_id: '',
					district_id: '',
					remake:''
				},
				formLabelWidth: '120px',
				rules: {
					user_nickname: [{ required: true, message: '请输入会员昵称', trigger: 'blur' }],
					group_id: [{ required: true, message: '请选择会员等级', trigger: 'blur' }],
					mobile: [{ required: true, message: '请输入手机号码', trigger: 'blur' }]
				},
				gradeList: []
		  };
		},
		watch:{
			status(val){
				this.dialogFormVisible = val;
				if (!val) {
					this.$refs['ruleForm'].resetFields();
				}
			},
			dialogFormVisible(newVal,oldVal) {
				if ((newVal != oldVal) && newVal) {
					this.initGradeList()
				}
			}
		},
		methods:{
			// 获取会员等级列表
			initGradeList() {
				this.$ajax({
					'method' : 'com.get.merchant_user.group.list',
				}).then(res => {
					if (res.status = 10000) {
						this.gradeList = res.data.list;
						// this.gradeList[0] ? this.form.group_id = this.gradeList[0].group_id : '';
					} else {
						this.$message.error(res.info);
					}
				})
			},
			getAddress(addressIds) {
				this.form.province_id = addressIds[0] || '';
				this.form.city_id = addressIds[1] || '';
				this.form.district_id = addressIds[2] || '';
			},
			submitTap(type,obj){
				if(type == '2'){
					this.submitForm(obj);
					return;
				} else {
					this.$emit('add',false,'cancel')
				}
				this.dialogFormVisible = false;
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
						const requestData = Object.assign({},{data: this.form},{'method' : 'com.set.merchant.user.save'});
						this.$ajax(requestData).then(res => {
							if (res.status == 10000) {
								this.messages('新增成功','success');
								this.$refs[formName].resetFields();
								this.$emit('add',false,'save');
							} else {
								this.$message.error(res.info);
							}
						})
				  } else {
					return false;
				  }
				});
			}
		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	.search_user_box{height:70px;}
	.pa_main_add_btn{font-size:16px;margin-top:18px;line-height:24px;font-weight:'bold';background:#fff;color:#999;text-align:center;}
	.pa_main_status_box{display:flex;}
	.pa_main_status_box .cols{width:16.6%;margin-left:10px;height:70px;padding:14px 0;color:#fff;border-radius:10px;text-align:center;}
	.pa_main_status_box .cols .numbers{font-size:34px;}
	
	.pa_main_search_inner{display:flex;padding:18px 0;}
	
	.pa_user_info_box{
		background:#fff;border-radius:10px;
		.img{
			width:60px;height:60px;border-radius:50%;
		}
		.text{
			padding:0 0 0 10px;
			.labels{display:block;width:40px;line-height:18px;margin-top:5px;background:#FF700B;text-align:center;color:#fff;font-size:12px;border-radius:6px;}
		}
		.el-icon-arrow-right{position:absolute;right:0;font-size:20px;}
		.over,.card{
			width:50%;text-align:center;
			span{display:block;margin-bottom:5px;font-size:18px;}
		}
		.pa_btn{margin-left:0;}
	}
</style>


// WEBPACK FOOTER //
// addUser.vue?bf0de2b6